import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PlaceIcon from '@mui/icons-material/Place';
import { useLocalizedPath } from '../../hooks';
import './index.css';

export const Footer = () => {
  const { t } = useTranslation();
  const localizedPath = useLocalizedPath();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to={localizedPath('/')}>
            <img
              src="/logo/logo_cropped.png"
              alt="Riga Dentique"
              className="footer-logo-img"
            />
          </Link>
          <div className="footer-brand-divider" />
          <p className="footer-tagline">{t('footer.tagline')}</p>
        </div>

        <div className="footer-nav">
          <Link to={localizedPath('/')} className="footer-link">
            {t('header.home')}
          </Link>
          <Link to={localizedPath('/about')} className="footer-link">
            {t('header.about')}
          </Link>
          <Link to={localizedPath('/pricing')} className="footer-link">
            {t('header.pricing')}
          </Link>
          <Link to={localizedPath('/contacts')} className="footer-link">
            {t('header.contacts')}
          </Link>
        </div>

        <div className="footer-contact">
          <a href="tel:+37126409932" className="footer-contact-item">
            <PhoneIcon fontSize="small" />
            <span>+371 26 409 932</span>
          </a>
          <a href="mailto:info@rigadentique.lv" className="footer-contact-item">
            <EmailIcon fontSize="small" />
            <span>info@rigadentique.lv</span>
          </a>
          <a
            href="https://maps.google.com/?q=Matīsa+iela+46+Rīga"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-contact-item"
          >
            <PlaceIcon fontSize="small" />
            <span>Matīsa iela 46, Rīga</span>
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © {year} Riga Dentique. All Rights Reserved.
        </p>
        <div className="footer-socials">
          <a
            href="https://www.instagram.com/rigadentique"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="footer-social-link"
          >
            <InstagramIcon fontSize="small" />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61563532634999"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="footer-social-link"
          >
            <FacebookIcon fontSize="small" />
          </a>
        </div>
      </div>
    </footer>
  );
};
